import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../index.css';

const GameRequestCard = ({ gameData }) => {
  const navigate = useNavigate();
  const [imageError, setImageError] = useState(false);

  const getPlatformIcon = (platform) => {
    const icons = {
      steam: '🎮',
      epic: '🏪',
      gog: '🕹️',
      xbox: '🎯',
      playstation: '🎲',
      nintendo: '🎴',
      origin: '🌟',
      uplay: '🏰',
      other: '📦'
    };
    return icons[platform] || '📦';
  };

  const getPlatformName = (platform) => {
    const names = {
      steam: 'Steam',
      epic: 'Epic Games',
      gog: 'GOG',
      xbox: 'Xbox',
      playstation: 'PlayStation',
      nintendo: 'Nintendo',
      origin: 'Origin',
      uplay: 'Uplay',
      other: 'Other'
    };
    return names[platform] || platform;
  };

  const handleClick = () => {
    navigate(`/code-requests/game/${encodeURIComponent(gameData.gameName)}`, {
      state: { platform: gameData.platform }
    });
  };

  return (
    <div className="game-request-card" onClick={handleClick}>
      <div className="game-request-banner">
        {gameData.gameBanner && !imageError ? (
          <img
            src={gameData.gameBanner}
            alt={gameData.gameName}
            onError={() => setImageError(true)}
            className="game-banner-img"
          />
        ) : (
          <div className="game-banner-placeholder">
            <span className="game-icon">🎮</span>
          </div>
        )}
        <div className="request-count-badge">
          {gameData.requestCount} {gameData.requestCount === 1 ? 'request' : 'requests'}
        </div>
      </div>
      
      <div className="game-request-content">
        <h3 className="game-name" title={gameData.gameName}>
          {gameData.gameName}
        </h3>
        
        <div className="game-platform">
          <span className="platform-icon">{getPlatformIcon(gameData.platform)}</span>
          <span className="platform-name">{getPlatformName(gameData.platform)}</span>
        </div>

        {gameData.gameUrl && (
          <a
            href={gameData.gameUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="game-link"
            onClick={(e) => e.stopPropagation()}
          >
            View Game Page 🔗
          </a>
        )}
      </div>
    </div>
  );
};

export default GameRequestCard;
